<div class="slide-toggle d-flex">
  <input
    type="checkbox"
    [disabled]="disabled || forceDisabled()"
    [(ngModel)]="value"
  />
</div>
